<template>
  <div>
    <async-loader v-if="computedLoading" />
    <div v-else>
      <div container>
        <h1 class="_mbs">
          {{ computedGroup.groupName }} - {{ computedGroup.groupId }}
        </h1>
        <div grid>
          <div column>
            <labeled-data label="Group ID:" :data="computedGroup.groupId" />
          </div>
          <div column>
            <labeled-data
              label="Effective Date:"
              :data="formatDate(computedGroup.effectiveDate)"
            />
          </div>
          <div column>
            <labeled-data
              label="Term Date:"
              :data="formatDate(computedGroup.terminationDate)"
            />
          </div>
        </div>
        <div grid>
          <div column>
            <labeled-data
              label="Account Manager:"
              :data="computedGroup.accountManagerName"
            />
          </div>
          <div column>
            <labeled-data
              label="Account Manager Phone:"
              :data="computedGroup.accountManagerPhone"
            />
          </div>
          <div column>
            <labeled-data
              label="Account Manager Email:"
              :data="computedGroup.accountManagerEmail"
            />
          </div>
        </div>
      </div>
    </div>
    <collapsible-section class="_pt0 _pb0">
      <template #headerText>
        <p class="color-leaf">Subgroups</p>
      </template>
      <template #collapsibleSection>
        <div container>
          <search-input
            label="Filter Subgroups"
            name="searchGroup"
            v-model="subGroupSearch"
            class="_mbs -full-width"
          />
          <advanced-table
            :headers="subGroupHeaders"
            :items="computedSubGroups"
            :rowsPerPage="20"
            :clickable="true"
            :search="subGroupSearch"
            @cellClicked="cellClicked"
            class="_p0"
          >
          </advanced-table>
        </div>
      </template>
    </collapsible-section>
  </div>
</template>

<script>
import SearchInput from '@atoms/SearchInput';
import LabeledData from '@molecules/LabeledData';
import AsyncLoader from '@molecules/AsyncLoader';
import CollapsibleSection from '@sections/CollapsibleSection';
import AdvancedTable from '@organisms/AdvancedTable.vue';

import GroupApi from '@api/GroupApi';

import formattable from '@mixins/formattable';

export default {
  mixins: [formattable],
  components: {
    CollapsibleSection,
    AdvancedTable,
    LabeledData,
    AsyncLoader,
    SearchInput
  },
  data() {
    return {
      subGroupSearch: '',
      groups: {},
      subGroupHeaders: [
        { text: 'Subgroup ID', align: 'left', value: 'subGroupId' },
        { text: 'Subgroup Name', value: 'subGroupName' },
        { text: 'Effective Date', value: 'effectiveDate' },
        { text: 'Term Date', value: 'terminationDate' }
      ]
    };
  },
  computed: {
    groupId() {
      return this.$store.getters['groupSelector/groupDetailId'];
    },
    computedLoading() {
      return Object.keys(this.groups).length === 0;
    },
    computedGroup() {
      if (!this.groups || this.groups.length === 0) {
        return {};
      }

      return this.groups[0];
    },
    computedSubGroups() {
      if (!this.computedGroup || !this.computedGroup.subGroups) {
        return [];
      }

      return this.computedGroup.subGroups.map(sg => ({
        subGroupName: sg.subGroupName,
        subGroupId: sg.subGroupId,
        subGroupCk: sg.subGroupCk,
        groupCk: this.computedGroup.groupCk,
        effectiveDate: this.formatDate(sg.effectiveDate),
        terminationDate: this.formatDate(sg.terminationDate)
      }));
    }
  },
  methods: {
    cellClicked(cell) {
      this.$store.commit(
        'groupSelector/SET_SUB_GROUP_DETAIL_CK',
        cell.subGroupCk
      );
      this.$store.commit('groupSelector/SET_GROUP_DETAIL_CK', cell.groupCk);
      this.$router.push({
        name: 'subgroup'
      });
    },
    fetchData() {
      new GroupApi({ simulateExample: 'Group Search - Group Id Search' })
        .search({
          id: this.groupId,
          name: '',
          isParentGroupSearch: false
        })
        .then(res => {
          this.groups = res.groups;
        })
        .catch(err => {
          // TODO handle error
          console.log('err', err);
        });
    }
  },
  created() {
    this.fetchData();
  },
  watch: {
    groupId(newItem, oldItem) {
      this.fetchData();
    }
  }
};
</script>
